import script from "./OperationLog.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperationLog.vue?vue&type=script&lang=ts&setup=true"

import "./OperationLog.vue?vue&type=style&index=0&id=90a94652&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90a94652"]])

export default __exports__